import React, { useState } from 'react';
import './ScamSteps.css';

const steps = [
  {
    num: '01',
    icon: '📱',
    title: 'Le piège TikTok',
    color: 'var(--yellow)',
    desc: 'Une publicité alléchante apparaît sur votre fil TikTok. Un tapis de course, un aspirateur, un gadget à prix cassé — souvent entre 19€ et 39€. La vidéo semble légitime, le produit existe vraiment.',
    detail: 'Les escrocs achètent de vraies publicités TikTok ou créent de faux comptes avec de vrais produits photo-volés. Le lien redirige vers un intermédiaire avant JumpVendor.',
    warning: 'Le vrai danger : vous croyez commander sur TikTok Shop ou un site normal.'
  },
  {
    num: '02',
    icon: '🔀',
    title: 'La redirection cachée',
    color: 'var(--orange)',
    desc: 'Après avoir cliqué "Acheter", vous êtes redirigé silencieusement vers JumpVendor.com. Le domaine change dans la barre d\'adresse mais la page ressemble à celle du produit. Vous pensez toujours être sur le bon site.',
    detail: 'La technique utilisée s\'appelle "affiliate fraud" : un lien affilié dissimule la vraie destination. Le design est copié pour ne pas éveiller les soupçons.',
    warning: 'Conseil : Vérifiez TOUJOURS l\'URL dans la barre d\'adresse avant de saisir vos coordonnées bancaires.'
  },
  {
    num: '03',
    icon: '💳',
    title: '3 prélèvements surprise',
    color: 'var(--red-bright)',
    desc: 'Vous renseignez votre carte bancaire pour payer les ~30€ du produit. Mais en quelques jours, TROIS montants différents apparaissent sur votre relevé bancaire — souvent séparés de quelques jours pour ne pas alerter immédiatement.',
    detail: 'Prélèvement 1 : le "produit" (souvent inexistant). Prélèvement 2 : frais d\'activation cachés. Prélèvement 3 : abonnement mensuel activé via une case pré-cochée ou mention en petits caractères.',
    warning: 'Montants observés : 9,99€ + 29,99€ + 49€ ou variations similaires.'
  },
  {
    num: '04',
    icon: '📦',
    title: 'Le produit n\'arrive jamais',
    color: 'var(--orange)',
    desc: 'Le produit commandé n\'est jamais livré, ou une contrefaçon de mauvaise qualité arrive plusieurs semaines plus tard. Le service client est injoignable ou répond en anglais avec des réponses génériques.',
    detail: 'Quand vous contactez JumpVendor, ils invoquent des délais "logistiques", des adresses incorrectes, ou prétendent que la livraison a bien eu lieu. Aucune preuve de suivi fiable n\'est fournie.',
    warning: 'Le numéro de suivi fourni pointe vers un colis fictif ou un autre destinataire.'
  },
  {
    num: '05',
    icon: '🔄',
    title: 'L\'abonnement piège',
    color: 'var(--red)',
    desc: 'Le pire : en validant votre paiement, vous avez accepté des CGV qui activaient un abonnement mensuel. JumpVendor continue de vous prélever chaque mois jusqu\'à ce que vous les contactiez — et la résiliation est volontairement rendue difficile.',
    detail: 'Les CGV frauduleuses sont rédigées en petits caractères, parfois dans une autre langue, avec la case "Je refuse l\'abonnement" pré-cochée ou inversée. Légalement, c\'est du dark pattern — illégal en France.',
    warning: 'Résultat : certaines victimes ont perdu 200€+ avant de se rendre compte de l\'abonnement.'
  },
];

export default function ScamSteps() {
  const [open, setOpen] = useState(null);

  return (
    <section className="scam-steps section" id="comment-ca-marche" aria-labelledby="scam-title">
      <div className="container">
        <span className="tag">Comment ils opèrent</span>
        <h2 id="scam-title" className="section-title" style={{ color: 'var(--red-bright)' }}>
          Le Système d'Arnaque en 5 Étapes
        </h2>
        <p className="section-subtitle">
          Une mécanique bien rodée, conçue pour tromper le maximum de victimes sans éveiller les soupçons.
        </p>

        <div className="steps-list" role="list">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`step-card ${open === i ? 'step-card--open' : ''}`}
              role="listitem"
              style={{ '--step-color': step.color }}
            >
              <button
                className="step-card__header"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
                aria-controls={`step-body-${i}`}
              >
                <div className="step-card__num">{step.num}</div>
                <div className="step-card__icon">{step.icon}</div>
                <div className="step-card__title">{step.title}</div>
                <div className="step-card__arrow">{open === i ? '▲' : '▼'}</div>
              </button>

              <div id={`step-body-${i}`} className="step-card__body" aria-hidden={open !== i}>
                <p className="step-card__desc">{step.desc}</p>
                <div className="step-card__detail">
                  <strong>🔍 En détail :</strong> {step.detail}
                </div>
                <div className="step-card__warning">
                  <strong>⚠️</strong> {step.warning}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
